import {
  ARCHIVING_DATE_ROUTE_TYPES,
  INDEXING_FIELD_TYPES,
  walkFields,
  type ElementType,
  type FormElement,
} from '@record-fill';
import type { MatrixField } from '../model/matrix-field.types';

const INDEXING_TYPES: ReadonlySet<ElementType> = new Set(INDEXING_FIELD_TYPES);
const DATE_TYPES: ReadonlySet<ElementType> = new Set(ARCHIVING_DATE_ROUTE_TYPES);

export function collectMatrixFields(elements: ReadonlyArray<FormElement>): MatrixField[] {
  const fields: MatrixField[] = [];

  for (const element of elements) {
    const inTable = element.type === 'TABLE';
    for (const field of walkFields([element])) {
      const label = field.properties.label?.trim();
      fields.push({
        name: field.properties.name,
        ...(label ? { label } : {}),
        type: field.type,
        inTable,
      });
    }
  }

  return fields;
}

export function getIndexingFields(fields: ReadonlyArray<MatrixField>): MatrixField[] {
  return fields.filter((field) => INDEXING_TYPES.has(field.type));
}

export function getDateFields(fields: ReadonlyArray<MatrixField>): MatrixField[] {
  return fields.filter((field) => DATE_TYPES.has(field.type));
}

export function getTextFields(fields: ReadonlyArray<MatrixField>): MatrixField[] {
  return fields.filter((field) => field.type === 'TEXT_INPUT');
}

export function filterFieldsByName(
  fields: ReadonlyArray<MatrixField>,
  searchTerm: string
): MatrixField[] {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return [...fields];
  return fields.filter((field) => field.name.toLowerCase().includes(term));
}

export function formatFieldOptionLabel(field: MatrixField): string {
  return field.label ? `${field.name} (${field.label})` : field.name;
}
